module.exports = __webpack_public_path__ + "img/longblack-thumb.087617f9.png";